import {BaseFavourite} from './res/favourite/BaseFavourite';
import {BaseFavouriteFilled} from './res/favourite/BaseFavouriteFilled';
import {BaseWarningFilled} from './res/warning/BaseWarningFilled';
import {BaseWarning} from './res/warning/BaseWarning';
import {BaseSpacing} from './res/spacing/BaseSpacing';
import {BaseSearch} from './res/search/BaseSearch';
import {BaseSearchFilled} from './res/search/BaseSearchFilled';
import {BaseRemove} from './res/remove/BaseRemove';
import {BaseRemoveFilled} from './res/remove/BaseRemoveFilled';
import {BasePlusCircle} from './res/plusCircle/BasePlusCircle';
import {BasePlusCircleFilled} from './res/plusCircle/BasePlusCircleFilled';
import {BaseComment} from './res/comment/BaseComment';
import {BaseCommentFilled} from './res/comment/BaseCommentFilled';
import {BaseCheckmark} from './res/checkmark/BaseCheckmark';
import {BaseCheckmarkSmall} from './res/checkmarkSmall/BaseCheckmarkSmall';
import {BaseDrag} from './res/drag/BaseDrag';
import {BaseDoorstep} from './res/doorstep/BaseDoorstep';
import {BaseDoorstepFilled} from './res/doorstep/BaseDoorstepFilled';
import {BaseDoubleArrowLeft} from './res/doubleArrowLeft/BaseDoubleArrowLeft';
import {BaseEdit} from './res/edit/BaseEdit';
import {BaseEditFilled} from './res/edit/BaseEditFilled';
import {BaseArrowDownSmall} from './res/arrowDownSmall/BaseArrowDownSmall';
import {BaseArrowLeft} from './res/arrowLeft/BaseArrowLeft';
import {BaseArrowLeftSmall} from './res/arrowLeftSmall/BaseArrowLeftSmall';
import {BaseArrowRight} from './res/arrowRight/BaseArrowRight';
import {BaseArrowRightSmall} from './res/arrowRightSmall/BaseArrowRightSmall';
import {BaseArrowUpSmall} from './res/arrowUpSmall/BaseArrowUpSmall';
import {BaseClose} from './res/close/BaseClose';
import {BaseCloseCircle} from './res/closeCircle/BaseCloseCircle';
import {BaseCloseCircleFilled} from './res/closeCircle/BaseCloseCirlceFilled';
import {BaseFlash} from './res/flash/BaseFlash';
import {BaseFlashFilled} from './res/flash/BaseflashFilled';
import {BaseGlobe} from './res/globe/BaseGlobe';
import {BaseGlobeFilled} from './res/globe/BaseGlobeFilled';
import {BaseHomeFilled} from './res/home/BaseHomeFilled';
import {BaseHome} from './res/home/BaseHome';
import {BaseImage} from './res/image/BaseImage';
import {BaseImageFilled} from './res/image/BaseImageFilled';
import {BaseLike} from './res/like/BaseLike';
import {BaseLikeFilled} from './res/like/BaseLikeFilled';
import {BaseLinebreak} from './res/linebreak/BaseLinebreak';
import {BaseLinebreakFilled} from './res/linebreak/BaseLinebreakFilled';
import {BaseLocation} from './res/location/BaseLocation';
import {BaseLocationFilled} from './res/location/BaseLocationFilled';
import {BaseMagazine} from './res/magazine/BaseMagazine';
import {BaseMagazineFilled} from './res/magazine/BaseMagazineFilled';
import {BaseMagazineAdressed} from './res/magazineAdressed/BaseMagazineAdressed';
import {BaseMagazineAdressedFilled} from './res/magazineAdressed/BaseMagazineAdressedFilled';
import {BaseMailbox} from './res/mailbox/BaseMailbox';
import {BaseMailboxFilled} from './res/mailbox/BaseMailboxFilled';
import {BaseMailboxes} from './res/mailboxes/BaseMailboxes';
import {BaseMailboxesFilled} from './res/mailboxes/BaseMailboxesFilled';
import {BaseMap} from './res/map/BaseMap';
import {BaseMapFilled} from './res/map/BaseMapFilled';
import {BaseMenu} from './res/menu/BaseMenu';
import {BaseMinus} from './res/minus/BaseMinus';
import {BaseMore} from './res/more/BaseMore';
import {BaseMyLocation} from './res/myLocation/BaseMyLocation';
import {BaseMyLocationFilled} from './res/myLocation/BaseMyLocationFilled';
import {BaseNearMe} from './res/nearMe/BaseNearMe';
import {BaseNearMeFilled} from './res/nearMe/BaseNearMeFilled';
import {BaseNewspaper} from './res/newspaper/BaseNewspaper';
import {BaseNewspaperFilled} from './res/newspaper/BaseNewspaperFilled';
import {BasePackage} from './res/package/BasePackage';
import {BasePackageFilled} from './res/package/BasePackageFilled';
import {BasePlus} from './res/plus/BasePlus';
import {BaseCalendar} from './res/calendar/BaseCalendar';
import {BaseCalendarFilled} from './res/calendar/BaseCalendarFilled';
import {BaseCheckmarkThick} from './res/checkmark/BaseCheckmarkThick';
import {BaseMinusThick} from './res/minus/BaseMinusThick';
import {BaseVacation} from './res/vacation/BaseVacation';
import {BaseVacationFilled} from './res/vacation/BaseVacationFilled';
import {BaseTrolley} from './res/trolley/BaseTrolley';
import {BaseTrolleyFilled} from './res/trolley/BaseTrolleyFilled';
import {BaseSickChild} from './res/sickChild/BaseSickCfild';
import {BaseSickChildFilled} from './res/sickChild/BaseSickChildFilled';
import {BaseSick} from './res/sick/BaseSick';
import {BaseSickFilled} from './res/sick/BaseSickFilled';
import {BasePaxter} from './res/paxter/BasePaxter';
import {BasePaxterFilled} from './res/paxter/BasePaxterFilled';
import {BaseCopy} from './res/copy/BaseCopy';
import {BaseCopyFilled} from './res/copy/BaseCopyFilled';
import {BaseCompassionateLeave} from './res/compassionateLeave/BaseCompassionateLeave';
import {BaseCompassionateLeaveFilled} from './res/compassionateLeave/BaseCompassionateLeaveFilled';
import {BaseCar} from './res/car/BaseCar';
import {BaseCarFilled} from './res/car/BaseCarFilled';
import {BaseAbsence} from './res/absence/BaseAbsence';
import {BaseDoubleArrowRight} from './res/doubleArrowRight/BaseDoubleArrowRight';
import {BaseDrawer} from './res/drawer/BaseDrawer';

export const iconMap = {
  favourite: {
    outline: BaseFavourite,
    filled: BaseFavouriteFilled,
  },
  warning: {
    outline: BaseWarning,
    filled: BaseWarningFilled,
  },
  search: {
    outline: BaseSearch,
    filled: BaseSearchFilled,
  },
  remove: {
    outline: BaseRemove,
    filled: BaseRemoveFilled,
  },
  plusCircle: {
    outline: BasePlusCircle,
    filled: BasePlusCircleFilled,
  },
  comment: {
    outline: BaseComment,
    filled: BaseCommentFilled,
  },
  doorstep: {
    outline: BaseDoorstep,
    filled: BaseDoorstepFilled,
  },
  edit: {
    outline: BaseEdit,
    filled: BaseEditFilled,
  },
  checkmark: {
    outline: BaseCheckmark,
    filled: BaseCheckmark,
  },
  checkmarkSmall: {
    outline: BaseCheckmarkSmall,
    filled: BaseCheckmarkSmall,
  },
  spacing: {
    outline: BaseSpacing,
    filled: BaseSpacing,
  },
  drag: {
    outline: BaseDrag,
    filled: BaseDrag,
  },
  doubleArrowLeft: {
    outline: BaseDoubleArrowLeft,
    filled: BaseDoubleArrowLeft,
  },
  arrowDownSmall: {
    outline: BaseArrowDownSmall,
    filled: BaseArrowDownSmall,
  },
  arrowLeft: {
    outline: BaseArrowLeft,
    filled: BaseArrowLeft,
  },
  arrowLeftSmall: {
    outline: BaseArrowLeftSmall,
    filled: BaseArrowLeftSmall,
  },
  arrowRight: {
    outline: BaseArrowRight,
    filled: BaseArrowRight,
  },
  arrowRightSmall: {
    outline: BaseArrowRightSmall,
    filled: BaseArrowRightSmall,
  },
  arrowUpSmall: {
    outline: BaseArrowUpSmall,
    filled: BaseArrowUpSmall,
  },
  close: {
    outline: BaseClose,
    filled: BaseClose,
  },
  closeCircle: {
    outline: BaseCloseCircle,
    filled: BaseCloseCircleFilled,
  },
  flash: {
    outline: BaseFlash,
    filled: BaseFlashFilled,
  },
  globe: {
    outline: BaseGlobe,
    filled: BaseGlobeFilled,
  },
  home: {
    outline: BaseHome,
    filled: BaseHomeFilled,
  },
  image: {
    outline: BaseImage,
    filled: BaseImageFilled,
  },
  like: {
    outline: BaseLike,
    filled: BaseLikeFilled,
  },
  lineBreak: {
    outline: BaseLinebreak,
    filled: BaseLinebreakFilled,
  },
  location: {
    outline: BaseLocation,
    filled: BaseLocationFilled,
  },
  magazine: {
    outline: BaseMagazine,
    filled: BaseMagazineFilled,
  },
  magazineAdressed: {
    outline: BaseMagazineAdressed,
    filled: BaseMagazineAdressedFilled,
  },
  mailbox: {
    outline: BaseMailbox,
    filled: BaseMailboxFilled,
  },
  mailboxes: {
    outline: BaseMailboxes,
    filled: BaseMailboxesFilled,
  },
  map: {
    outline: BaseMap,
    filled: BaseMapFilled,
  },
  menu: {
    outline: BaseMenu,
    filled: BaseMenu,
  },
  minus: {
    outline: BaseMinus,
    filled: BaseMinus,
  },
  more: {
    outline: BaseMore,
    filled: BaseMore,
  },
  myLocation: {
    outline: BaseMyLocation,
    filled: BaseMyLocationFilled,
  },
  nearMe: {
    outline: BaseNearMe,
    filled: BaseNearMeFilled,
  },
  newspaper: {
    outline: BaseNewspaper,
    filled: BaseNewspaperFilled,
  },
  package: {
    outline: BasePackage,
    filled: BasePackageFilled,
  },
  plus: {
    outline: BasePlus,
    filled: BasePlus,
  },
  calendar: {
    outline: BaseCalendar,
    filled: BaseCalendarFilled,
  },
  vacation: {
    outline: BaseVacation,
    filled: BaseVacationFilled,
  },
  trolley: {
    outline: BaseTrolley,
    filled: BaseTrolleyFilled,
  },
  sickChild: {
    outline: BaseSickChild,
    filled: BaseSickChildFilled,
  },
  sick: {
    outline: BaseSick,
    filled: BaseSickFilled,
  },
  paxter: {
    outline: BasePaxter,
    filled: BasePaxterFilled,
  },
  copy: {
    outline: BaseCopy,
    filled: BaseCopyFilled,
  },
  compassionateLeave: {
    outline: BaseCompassionateLeave,
    filled: BaseCompassionateLeaveFilled,
  },
  car: {
    outline: BaseCar,
    filled: BaseCarFilled,
  },
  absence: {
    outline: BaseAbsence,
    filled: BaseAbsence,
  },
  checkmarkThick: {
    outline: BaseCheckmarkThick,
    filled: BaseCheckmarkThick,
  },
  minusThick: {
    outline: BaseMinusThick,
    filled: BaseMinusThick,
  },
  doubleArrowRight: {
    outline: BaseDoubleArrowRight,
    filled: BaseDoubleArrowRight,
  },
  drawer: {
    outline: BaseDrawer,
    filled: BaseDrawer,
  },
};
